/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllQueryableTableAssignmentsResponse } from '../../models/get-all-queryable-table-assignments-response';

export interface GetQueryableTableAssignmentsByOrganizationIdAndAuthorizedParty$Params {
  organizationId: string;
  authorizedParty: string;
}

export function getQueryableTableAssignmentsByOrganizationIdAndAuthorizedParty(http: HttpClient, rootUrl: string, params: GetQueryableTableAssignmentsByOrganizationIdAndAuthorizedParty$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllQueryableTableAssignmentsResponse>> {
  const rb = new RequestBuilder(rootUrl, getQueryableTableAssignmentsByOrganizationIdAndAuthorizedParty.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('authorizedParty', params.authorizedParty, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllQueryableTableAssignmentsResponse>;
    })
  );
}

getQueryableTableAssignmentsByOrganizationIdAndAuthorizedParty.PATH = '/v1/organizations/{organizationId}/graphql/queryableTableAssignments/{authorizedParty}';
